export abstract class AbstractError extends Error {
    public abstract readonly code: number;
    public readonly args?: string[];

    constructor(message: string, args?: string[]) {
        super(message);
        this.name = this.constructor.name;
        this.args = args;
    }
}
